// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__Q8gl4","title":"styles_title__66x_r","content":"styles_content__rcj_w"};